// export default {}
import ScrollToTop from './ScrollToTop';

export default {
    methods: [ScrollToTop],
    components: {}
}